import { gql } from '@apollo/client/core'

export const GET_OR_CREATE_CALENDAR = gql`
  mutation GetOrCreateCalendar($input: GetOrCreateCalendarInput!) {
    getOrCreateCalendar(input: $input) {
      calendar_id
      uuid
      practice_id
      calendar_owner_id
      calendar_name
      timezone
      google_calendar_ids
      outlook_calendar_ids
      zoom_calendar_ids
      is_active
      created_at
      updated_at
      role
      calendar_owner_firstname
      calendar_owner_lastname
    }
  }
`

export const CREATE_EVENT = gql`
  mutation CreateEvent($input: CreateEventInput!) {
    createEvent(input: $input) {
      event_id
      uuid
      event_title
      notes
      internal_notes
      practice_id
      creator_calendar_id
      event_type
      color_id
      start_time
      end_time
      timezone
      rrule
      is_canceled
      participants {
        participant_calendar_id
        role
        status
      }
    }
  }
`

export const UPDATE_EVENT = gql`
  mutation UpdateEvent($input: UpdateEventInput!) {
    updateEvent(input: $input) {
      event_id
      uuid
      event_title
      notes
      internal_notes
      practice_id
      creator_calendar_id
      event_type
      color_id
      external_url
      google_event_id
      outlook_event_id
      zoom_event_id
      is_canceled
      start_time
      end_time
      timezone
      location
      rrule
      recurrence_id
      patient_ids
      create_time
      update_time
      participants {
        id
        event_id
        participant_calendar_id
        role
        status
        created_at
        updated_at
      }
    }
  }
`

export const DELETE_EVENT = gql`
  mutation DeleteEvent($input: DeleteEventInput!) {
    deleteEvent(input: $input) {
      success
      message
      event_id
    }
  }
`

export const UPDATE_MEETING_REQUEST_FOR_ME= gql`
  mutation UpdateMeetingRequestForMe($input: UpdateMeetingRequestForMeInput!) {
    updateMeetingRequestForMe(input: $input) {
      success
      message
      meeting_request {
        id
        uuid
        patient_calendar_id
        patient_firstname
        patient_lastname
        provider {
          first_name
          last_name
          customer_id
        }
        clinic {
          clinic_id
          clinic_name
        }
        requested_start_time
        requested_end_time
        topic
        notes
        status
        cancellation_reason
        created_at
        updated_at
        accepted_meeting_id
        is_conflicted
      }
      event_id
    }
  }
`

export const CREATE_TASK = gql`
  mutation CreateTask($input: TaskInput!) {
    createTask(input: $input) {
      success
      message
      task {
        task_id
        uuid
        title
        description
        priority
        due_date
        rrule
        is_completed
        category
      }
      errors {
        field
        message
      }
    }
  }
`

export const UPDATE_TASK = gql`
  mutation UpdateTask($id: Int!, $input: TaskUpdateInput!) {
    updateTask(id: $id, input: $input) {
      success
      message
      task {
        task_id
        uuid
        title
        description
        priority
        due_date
        rrule
        is_completed
        category
      }
      errors {
        field
        message
      }
    }
  }
`

export const DELETE_TASK = gql`
  mutation DeleteTask($id: Int!) {
    deleteTask(id: $id) {
      success
      message
      task {
        task_id
        is_active
      }
      errors {
        field
        message
      }
    }
  }
`

export const COMPLETE_TASK = gql`
  mutation CompleteTask($id: Int!, $occurrenceDate: DateTime) {
    completeTask(id: $id, occurrenceDate: $occurrenceDate) {
      success
      message
      task {
        task_id
        is_completed
      }
    }
  }
`

export const UNCOMPLETE_TASK = gql`
  mutation UnCompleteTask($id: Int!, $occurrenceDate: DateTime) {
    unCompleteTask(id: $id, occurrenceDate: $occurrenceDate) {
      success
      message
      task {
        task_id
        is_completed
      }
    }
  }
`

export const CREATE_ZOOM_MEETING_WITHOUT_EVENT = gql`
  mutation CreateZoomMeetingWithoutEvent(
    $topic: String
    $startTime: String
    $duration: Int
    $timezone: String
  ) {
    createZoomMeetingWithoutEvent(
      topic: $topic
      startTime: $startTime
      duration: $duration
      timezone: $timezone
    ) {
      success
      meetingUrl
      meetingId
      error
    }
  }
`